import useTranslation from 'next-translate/useTranslation';
import { RichText } from 'components/atoms/RichText';
import { pdfCss } from './TagesPlanPdfDownload.styles';
import { TagesPlanPdfDownloadProps } from './TagesPlanPdfDownload.types';
import { LinkStyled, PdfContentStyled } from './TagesPlanPdfDownload.styles';

export const TagesPlanPdfDownload: React.FC<TagesPlanPdfDownloadProps> = ({
  className,
  slices,
  content,
}) => {
  const { t } = useTranslation('common');

  const sliceItem = slices.find((slice) => slice.slice_type === 'tagesplan-pdf');

  const print = () => {
    var pdfContentMarkup = document.getElementById('pdfContent');
    var win = window.open('', 'PRINT', 'height=600,width=600');

    if (pdfContentMarkup && win) {
      win.document.write('<html><head><title>Ballenberg TagesPlan</title>');
      win.document.write(`<style type="text/css">${pdfCss}</style>`);
      win.document.write('</head><body>');

      // Create a copy of the innerHTML
      const currentContent = pdfContentMarkup.innerHTML;
      const patternToReplace = /(\d{2}):(\d{2}) - (\d{2}):(\d{2})/g;
      const replacementString = '$1.$2 - $3.$4';

      // Perform the replacement on the copy
      const modifiedContent = currentContent.replace(patternToReplace, replacementString);

      // Use the modified copy for the print operation
      win.document.write(modifiedContent);
      win.document.write('</body></html>');
      win.document.close();

      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf('android') > -1; //&& ua.indexOf("mobile");
      if (isAndroid) {
        win.focus();
        win.print();

        win.onafterprint = () => {
          setTimeout(function () {
            if (win) {
              win.close();
            }
          }, 2000);
        };
      } else {
        win.onafterprint = () => {
          setTimeout(() => {
            if (win) {
              win.focus();
              win.print();
              win.close();
            }
          }, 250);
        };
      }

      return true;
    }
  };
  return (
    <>
      <LinkStyled
        skin="primary"
        icon="DOWNLOAD"
        className={className}
        text={t('pdfDownload')}
        onPress={() => print()}
        url={undefined}
        target="_blank"
      />
      <PdfContentStyled>
        <div id="pdfContent">
          {content}

          <div className="pdf-footer">
            {sliceItem && <RichText rich_text={sliceItem.primary['pdf-content']} />}
          </div>
        </div>
      </PdfContentStyled>
    </>
  );
};
